import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withRouter} from 'react-router-dom'

import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';


import { compose } from 'redux';
import { connect } from 'react-redux';




function Transition(props) {
    return <Slide direction="up" {...props} />;
  }

const mapStateToProps = (state) => {
  return {
    loading:state.Common.loading,
  };
}

const mapDispatchToProps = dispatch => ({
    
})

class Loader extends React.Component {
  state = {
    anchorEl: null,
    mobileMoreAnchorEl: null,
  };



  

  render() {
    const { anchorEl, mobileMoreAnchorEl } = this.state;
    const { classes } = this.props;
    const isMenuOpen = Boolean(anchorEl);
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

    

    

    return (
        <Dialog open={this.props.loading} onClose={this.handleClose} aria-labelledby="form-dialog-title" >
          <DialogTitle id="form-dialog-title"></DialogTitle>
          <DialogContent>
            <DialogContentText>
            
            </DialogContentText>

            <CircularProgress  />
            
          </DialogContent>
          <DialogActions>
            
          </DialogActions>
        </Dialog>
    );
  }
}

Loader.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(withRouter(Loader));
